<template>
  <div
    v-if="entries.length"
    class="upsi-activity-history"
    :data-testid="`${testIdPrefix}__history`"
  >
    <article
      v-for="(entry, index) in entries"
      :key="entry.id || index"
      class="upsi-activity-history__item"
      :class="{ 'upsi-activity-history__item--linked': index < entries.length - 1 }"
      :data-testid="`${testIdPrefix}__history-row--${index}`"
    >
      <FcUserAvatar
        :name="entry.actor"
        :size="32"
        :data-test-id="`${testIdPrefix}__history-avatar--${index}`"
      />
      <div class="upsi-activity-history__copy">
        <p class="upsi-activity-history__title">{{ entry.title }}</p>
        <p v-if="entry.metaLine" class="upsi-activity-history__meta">{{ entry.metaLine }}</p>
        <p v-if="entry.message" class="upsi-activity-history__message">{{ entry.message }}</p>
      </div>
    </article>
  </div>
</template>

<script>
import './UpsiActivityHistory.scss';
import { FcUserAvatar } from '@/modules/financialclose/components';
import { buildUpsiActivityEntries } from '../../components/upsi/upsiDialogUtils';

/** Shared UPSI activity timeline used by every compliance dialog. */
export default {
  name: 'UpsiActivityHistory',

  components: {
    FcUserAvatar,
  },

  props: {
    history: {
      type: Array,
      default: () => [],
    },
    filingReference: {
      type: String,
      default: '',
    },
    testIdPrefix: {
      type: String,
      default: 'upsi-activity-history',
    },
  },

  computed: {
    entries() {
      return buildUpsiActivityEntries(this.history, this.filingReference);
    },
  },
};
</script>
